import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";

import { loginRequest } from "../auth/msal";

export function SignIn() {
  const { instance } = useMsal();
  const { t } = useTranslation();
  return (
    <div className="signin">
      <div className="card">
        <div className="brand">
          <img src="/gw-mark.svg" alt="" className="brand-mark" />
          GATEWATCHER
        </div>
        <h1>whosout</h1>
        <p>{t("signIn.title")}</p>
        <button onClick={() => void instance.loginRedirect(loginRequest)}>
          {t("signIn.button")}
        </button>
      </div>
    </div>
  );
}
